(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7534],{

/***/ 47534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlogRegistration": function() { return /* binding */ BlogRegistration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _common_registration_box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39654);
/* harmony import */ var _blog_registration_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57057);
/* harmony import */ var _blog_registration_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_blog_registration_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var BlogRegistration = function BlogRegistration() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("section", {
    className: (_blog_registration_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section_blog_registration),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_common_registration_box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (BlogRegistration);

/***/ }),

/***/ 39654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22287);
/* harmony import */ var _registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var RegistrationBox = function RegistrationBox() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: (_registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5___default().choose_register_wrapper),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5___default().register),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5___default().register_title),
        children: "The Complete Platform"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
        className: (_registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5___default().register_sub_text),
        children: "With our AI-driven profile matching We find the universities that best fit you"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image_wrapper_mobile),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
          width: 1000,
          height: 400,
          src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/why-choose.jpg"),
          alt: "why choose",
          className: "border"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        legacyBehavior: true,
        href: "/signin",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
          className: "btn btn-secondary btn-md",
          children: "Register Now"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_registration_box_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image_wrapper),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        width: 1000,
        height: 400,
        src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/why-choose.jpg"),
        alt: "why choose"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RegistrationBox);

/***/ }),

/***/ 57057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_blog_registration":"blog_registration_section_blog_registration__3Oc1r"};

/***/ }),

/***/ 22287:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"choose_register_wrapper":"registration_box_choose_register_wrapper__ArF4K","register":"registration_box_register__oq3bt","register_title":"registration_box_register_title__mJTfU","register_sub_text":"registration_box_register_sub_text__CRMXO","image_wrapper_mobile":"registration_box_image_wrapper_mobile__Vcmq1","image_wrapper":"registration_box_image_wrapper__skcSq","choose_wrapper":"registration_box_choose_wrapper__Js7Q2","choose_list_wrapper":"registration_box_choose_list_wrapper__Sn_ed","mobile":"registration_box_mobile__fSzV6","title":"registration_box_title__gwccZ"};

/***/ })

}]);